import { EUserType } from '@aeCore/enums/user-role.enum';

export const USER_DEFAULT_ROUTES = {
  [EUserType.ADMIN]: 'admin/users-list',
  [EUserType.USER]: 'editor',
  [EUserType.SUPER_ADMIN]: 'admin/users-list',
};

